export const TRACK_NAME_LIST: Record<string, string> = {
  account_info: 'Product Application - Account Info - Viewed',
  positions: 'Product Application Select Positions - Viewed',
  licenses_and_certs: 'Product Application - Licenses and Certifications - Viewed',
  markets: 'Product Application - Select Market - Viewed',
  resume: 'Product Application - Resume - Viewed',
  q_and_a: 'Product Application - Questionnaire - Viewed',
  resume_review: 'Product Application - Application Received - Viewed',
  phone_screen_pending: 'Product Application - Schedule Phone Screen - Viewed',
  phone_screen_scheduled: 'Product Application - Phone Screen Scheduled - Viewed',
};
